import React from "react";

export default function ColorField({ label, value, onChange }) {
  return (
    <div className="mb-2">
      <label className="form-label small text-secondary text-uppercase">{label}</label>
      <div className="d-flex align-items-center gap-2 p-2 rounded  ">
        <div>
          <input
            type="color"
            value={value || "#000000"}
            onChange={(e) => onChange(e.target.value)}
            className="form-control form-control-color p-0"
            style={{ width: 40, padding: 0 }}
          />
        </div>
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="form-control form-control-sm text-monospace text-uppercase"
          placeholder="#000000"
        />
      </div>
    </div>
  );
}